export enum HookAction {
  INTERNAL_URL = 'INTERNAL_URL',
  EXTERNAL_URL = 'EXTERNAL_URL',
  INTERNAL_DOWNLOAD = 'INTERNAL_DOWNLOAD',
  EXTERNAL_DOWNLOAD = 'EXTERNAL_DOWNLOAD'
}